import { ListOfDataListItemResponse } from './Api/ListOfDataListItemResponse';

export class WorkstepTypeEntity extends ListOfDataListItemResponse {
	public static tryCast(o: any): WorkstepTypeEntity {
		const ret = new WorkstepTypeEntity();
		return Object.assign(ret, o);
	}
}
